module.exports = __webpack_public_path__ + "img/status-1.fa6cace4.svg";